import { handleHttpResponse } from "../../utils/http_response_utils";

export const getTaskLogs = async () => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/get-task-logs", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return await handleHttpResponse(response);
};

export const getLogStreamMongoData = async (logStreamName) => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch(
    "/api/get-log-stream-metadata?" + new URLSearchParams({ logStreamName: logStreamName }),
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
  return await handleHttpResponse(response);
};

export const getErrorList = async () => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/get-scraper-errors", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return await handleHttpResponse(response);
};

export const resolveErrorStatus = async (idArray) => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/update-error-status", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ _ids: idArray }),
  });
  return await handleHttpResponse(response);
};
